(function () {
  'use strict';

  var STORAGE_KEY = 'selected_state';
  var DEFAULT_MESSAGE = 'This product is not available in your state.';
  var productPageNoticeShown = false;
  var pendingReloadAfterClose = false;

  var ALL_STATES = [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District of Columbia", "Florida", 
    "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", 
    "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", 
    "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", 
    "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
  ];

  function getSelectedState() {
    try {
      var match = document.cookie.match(new RegExp('(^| )' + STORAGE_KEY + '=([^;]+)'));
      if (match) return decodeURIComponent(match[2]);
      return null;
    } catch (e) {
      return null;
    }
  }

  function setSelectedState(state) {
    try {
      document.cookie = STORAGE_KEY + '=' + encodeURIComponent(state) + '; path=/';
    } catch (e) {
      // cookie unavailable
    }
  }

  function isExcluded(excludedList, state) {
    if (!state || !excludedList || !excludedList.length) return false;
    return excludedList.indexOf(state) !== -1;
  }

  function parseJsonAttr(el, attr) {
    var raw = el.getAttribute(attr);
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      return parsed || [];
    } catch (e) {
      return [];
    }
  }

  function unavailableMessage(excludedList) {
    var base = window.hcUnavailableMessage || DEFAULT_MESSAGE;
    if (excludedList && excludedList.length) {
      var available = [];
      for (var i = 0; i < ALL_STATES.length; i++) {
        if (excludedList.indexOf(ALL_STATES[i]) === -1) {
          available.push(ALL_STATES[i]);
        }
      }
      
      if (available.length > 0) {
        var availableText = '';
        if (available.length === 1) {
          availableText = available[0];
        } else if (available.length === 2) {
          availableText = available[0] + ' and ' + available[1];
        } else {
          var last = available.pop();
          availableText = available.join(', ') + ', and ' + last;
        }
        // Ensure there's a space after the base message
        var prefix = base.trim();
        if (!prefix.endsWith('.')) prefix += '.';
        return prefix + ' Only available in ' + availableText + '.';
      }
    }
    return base;
  }

  // ---------------------------------------------------------------------
  // Modal
  // ---------------------------------------------------------------------
  // Opens the location popup. Pass an explicit message to show it in the popup's
  // notice area (e.g. when a blocked add-to-cart/checkout needs to surface a reason);
  // omit it to let the popup compute its own notice from the current page's product.
  function openModal(message) {
    var modal = document.getElementById('hc-state-modal');
    if (!modal) return;
    modal.classList.add('is-open');
    document.body.classList.add('hc-modal-open');
    if (message) {
      setModalNotice(message);
    } else {
      updateModalProductNotice();
    }
  }

  function setModalNotice(message) {
    var notice = document.getElementById('hc-state-modal-product-notice');
    if (!notice) return;
    if (message) {
      notice.textContent = message;
      notice.hidden = false;
    } else {
      notice.textContent = '';
      notice.hidden = true;
    }
  }

  // Shows/hides a notice inside the location popup itself when the page's current
  // product is excluded for the currently-selected state.
  function updateModalProductNotice() {
    var excluded = window.hcProductExclusions;
    var state = getSelectedState();

    if (state && excluded && excluded.length && isExcluded(excluded, state)) {
      setModalNotice(unavailableMessage(excluded));
    } else {
      setModalNotice(null);
    }
  }

  function closeModal() {
    var modal = document.getElementById('hc-state-modal');
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('hc-modal-open');
    if (pendingReloadAfterClose) {
      pendingReloadAfterClose = false;
      window.location.reload();
    }
  }

  function updateChangeStateLabel(state) {
    var label = document.getElementById('hc-current-state-label');
    if (label) label.textContent = state || '';
  }

  function initModal() {
    var modal = document.getElementById('hc-state-modal');
    if (!modal) return;

    var select = document.getElementById('hc-state-select');
    var confirmBtn = document.getElementById('hc-state-confirm');
    var closeBtn = document.getElementById('hc-state-modal-close');
    var changeBtn = document.getElementById('hc-change-state-btn');

    var saved = getSelectedState();
    if (saved && select) select.value = saved;
    updateChangeStateLabel(saved);
    updateModalProductNotice();

    if (!saved && (!window.Shopify || !Shopify.designMode)) {
      // Check if ageVerified cookie is true — if so, show popup immediately
      var ageMatch = document.cookie.match(/(^| )ageVerified=([^;]+)/);
      var ageVerified = ageMatch && ageMatch[2] === 'true';

      if (ageVerified) {
        openModal();
      } else {
        setTimeout(function() {
          if (!getSelectedState() && !document.getElementById('hc-state-modal').classList.contains('is-open')) {
            openModal();
          }
        }, 4000);
      }
    }

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        var value = select ? select.value : '';
        if (!value) {
          if (select) select.focus();
          return;
        }
        setSelectedState(value);
        updateChangeStateLabel(value);
        closeModal();
        document.dispatchEvent(new CustomEvent('hc:state-changed', { detail: { state: value } }));
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        // Only allow closing without picking a state if one was already chosen before
        if (!getSelectedState()) return;
        closeModal();
      });
    }

    if (changeBtn) {
      changeBtn.addEventListener('click', function () {
        openModal();
      });
    }
  }

  // ---------------------------------------------------------------------
  // Collection / search grid filtering
  // ---------------------------------------------------------------------
  function applyGridFiltering() {
    var state = getSelectedState();

    // Process forms with data-exclude-states attribute (collection page ATC buttons)
    document.querySelectorAll('form[data-exclude-states]').forEach(function (form) {
      var excluded = parseJsonAttr(form, 'data-exclude-states');
      var isRestricted = state && isExcluded(excluded, state);

      // Target all ATC elements: buttons, submit inputs, AND <a> links with .button-ATC
      form.querySelectorAll('[data-btn-addToCart], [type="submit"], .button-ATC').forEach(function (btn) {
        if (isRestricted) {
          btn.setAttribute('disabled', 'disabled');
          btn.classList.add('hc-disabled');

          // For <a> tags, also prevent navigation
          if (btn.tagName === 'A') {
            btn.setAttribute('data-hc-original-href', btn.getAttribute('href') || '');
            btn.removeAttribute('href');
          }

          // Wrap in tooltip if not already wrapped
          if (!btn.parentElement.classList.contains('hc-tooltip-wrap')) {
            var wrapper = document.createElement('div');
            wrapper.className = 'hc-tooltip-wrap';
            btn.parentNode.insertBefore(wrapper, btn);
            wrapper.appendChild(btn);
          }
          btn.parentElement.setAttribute('data-hc-tooltip', unavailableMessage(excluded));
        } else {
          // Clear restriction
          btn.removeAttribute('disabled');
          btn.classList.remove('hc-disabled');

          // Restore href for <a> tags
          if (btn.tagName === 'A' && btn.hasAttribute('data-hc-original-href')) {
            btn.setAttribute('href', btn.getAttribute('data-hc-original-href'));
            btn.removeAttribute('data-hc-original-href');
          }

          if (btn.parentElement && btn.parentElement.classList.contains('hc-tooltip-wrap')) {
            var wrap = btn.parentElement;
            wrap.parentNode.insertBefore(btn, wrap);
            wrap.remove();
          }
        }
      });
    });

    // Also handle old hcExclusionMap-based hiding if present
    var map = window.hcExclusionMap;
    if (!map) return;

    document.querySelectorAll('.product-item[data-product-id]').forEach(function (el) {
      var id = el.getAttribute('data-product-id');
      var excluded = map[id];
      var wrapper = el.closest('li.product') || el;
      if (state && isExcluded(excluded, state)) {
        wrapper.setAttribute('data-hc-hidden', 'true');
        wrapper.style.display = 'none';
      } else if (wrapper.getAttribute('data-hc-hidden') === 'true') {
        wrapper.removeAttribute('data-hc-hidden');
        wrapper.style.display = '';
      }
    });
  }

  function observeGrid() {
    if (!('MutationObserver' in window)) return;
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        applyGridFiltering();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ---------------------------------------------------------------------
  // Product page protection
  // ---------------------------------------------------------------------
  function applyProductPageRestriction() {
    updateModalProductNotice();

    var excluded = window.hcProductExclusions;
    if (!excluded || !excluded.length) return;
    var state = getSelectedState();

    if (!state || !isExcluded(excluded, state)) {
      clearProductPageRestriction();
      return;
    }

    var message = unavailableMessage(excluded);

    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function (form) {
      var formProductId = form.getAttribute('data-product-id');
      if (formProductId && window.hcCurrentProductId && formProductId !== window.hcCurrentProductId) return;

      form.querySelectorAll('[type="submit"], [data-btn-addToCart]').forEach(function (btn) {
        btn.setAttribute('disabled', 'disabled');
        btn.classList.add('hc-disabled');

        // Wrap button in a tooltip container if not already wrapped
        if (!btn.parentElement.classList.contains('hc-tooltip-wrap')) {
          var wrapper = document.createElement('div');
          wrapper.className = 'hc-tooltip-wrap';
          btn.parentNode.insertBefore(wrapper, btn);
          wrapper.appendChild(btn);
        }
        var wrap = btn.parentElement;
        // Set or update tooltip text
        wrap.setAttribute('data-hc-tooltip', message);
      });

      form.querySelectorAll('input[name="id"], input[name="quantity"], select[name="id"]').forEach(function (input) {
        input.setAttribute('disabled', 'disabled');
        input.classList.add('hc-disabled-input');
      });
    });

    // Do NOT open the modal popup - just keep button disabled with tooltip
    productPageNoticeShown = true;
  }

  function clearProductPageRestriction() {
    // Unwrap buttons from tooltip wrappers
    document.querySelectorAll('.hc-tooltip-wrap').forEach(function (wrap) {
      var btn = wrap.querySelector('[type="submit"], [data-btn-addToCart]');
      if (btn) {
        btn.removeAttribute('disabled');
        btn.classList.remove('hc-disabled');
        wrap.parentNode.insertBefore(btn, wrap);
      }
      wrap.remove();
    });
    document.querySelectorAll('form[action*="/cart/add"] [data-btn-addToCart].hc-disabled, form[action*="/cart/add"] [type="submit"].hc-disabled').forEach(function (btn) {
      btn.removeAttribute('disabled');
      btn.classList.remove('hc-disabled');
    });
    document.querySelectorAll('form[action*="/cart/add"] .hc-disabled-input').forEach(function (input) {
      input.removeAttribute('disabled');
      input.classList.remove('hc-disabled-input');
    });
    productPageNoticeShown = false;
    setModalNotice(null);
  }

  // Universal guard - covers the main product page form plus quick-add/quick-view/sticky-bar
  // forms, since every Shopify add-to-cart form posts to an action containing "/cart/add".
  function initFormGuard() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || typeof form.matches !== 'function') return;
      if (!form.matches('form[action*="/cart/add"]')) return;

      var state = getSelectedState();
      if (!state) return;

      var productId = form.getAttribute('data-product-id');
      var excludedList = null;

      if (productId && window.hcExclusionMap && window.hcExclusionMap[productId]) {
        excludedList = window.hcExclusionMap[productId];
      } else if (!productId || (window.hcCurrentProductId && productId === window.hcCurrentProductId)) {
        // No data-product-id (the main PDP form) or it explicitly matches the page's product.
        excludedList = window.hcProductExclusions;
      }

      if (isExcluded(excludedList, state)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openModal(unavailableMessage(excludedList));
      }
    }, true);
  }

  // ---------------------------------------------------------------------
  // Cart page protection
  // ---------------------------------------------------------------------
  function getRestrictedCartRows(state) {
    var rows = [];
    document.querySelectorAll('.cart-item[data-exclude-states]').forEach(function (row) {
      var excluded = parseJsonAttr(row, 'data-exclude-states');
      if (isExcluded(excluded, state)) rows.push(row);
    });
    return rows;
  }

  function removeCartLine(lineKey) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
  }

  function cleanCartItems() {
    var state = getSelectedState();
    if (!state) return Promise.resolve(false);

    var rows = getRestrictedCartRows(state);
    if (!rows.length) return Promise.resolve(false);

    var names = rows.map(function (row) {
      var titleEl = row.querySelector('.cart-item-title, [data-cart-item-title], a');
      return titleEl ? titleEl.textContent.trim() : 'An item';
    });

    var chain = Promise.resolve();
    rows.forEach(function (row) {
      var lineKey = row.getAttribute('data-line');
      chain = chain.then(function () {
        return removeCartLine(lineKey);
      });
    });

    return chain
      .then(function () {
        showCartNotice(names);
        return true;
      })
      .catch(function () {
        return false;
      });
  }

  function showCartNotice(names) {
    var existing = document.querySelector('.hc-cart-notice');
    if (existing) existing.remove();

    var notice = document.createElement('div');
    notice.className = 'hc-cart-notice';
    var verb = names.length > 1 ? 'were' : 'was';
    notice.textContent = names.join(', ') + ' ' + verb + ' not available in your state and ' + (names.length > 1 ? 'were' : 'was') + ' removed from your cart.';
    document.body.appendChild(notice);
    setTimeout(function () {
      notice.remove();
    }, 6000);
  }

  function initCartPage() {
    if (!document.querySelector('.cart-item[data-exclude-states]')) return;
    cleanCartItems().then(function (removed) {
      if (removed) {
        setTimeout(function () {
          window.location.reload();
        }, 1200);
      }
    });
  }

  // ---------------------------------------------------------------------
  // Checkout guard - runs on the capture phase so it executes before the
  // theme's own checkout-button click handler in assets/cart.js.
  // ---------------------------------------------------------------------
  function initCheckoutGuard() {
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest('#cart-checkout, .button-checkout');
        if (!btn) return;

        var state = getSelectedState();
        if (!state) return;

        var restricted = getRestrictedCartRows(state);
        if (!restricted.length) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        cleanCartItems().then(function () {
          pendingReloadAfterClose = true;
          openModal('Some items in your cart are not available in your state and have been removed. Please review your cart and try checkout again.');
        });
      },
      true
    );
  }

  // ---------------------------------------------------------------------
  // Init
  // ---------------------------------------------------------------------
  function init() {
    initModal();
    applyGridFiltering();
    observeGrid();
    applyProductPageRestriction();
    initFormGuard();
    initCartPage();
    initCheckoutGuard();
    initTooltipClick();

    document.addEventListener('hc:state-changed', function () {
      applyGridFiltering();
      applyProductPageRestriction();
      initCartPage();
      initTooltipClick();
    });
  }

  // Tap-to-show tooltip on mobile (hover doesn't work on touch)
  function initTooltipClick() {
    document.addEventListener('click', function (e) {
      var wrap = e.target.closest('.hc-tooltip-wrap');
      if (wrap) {
        e.preventDefault();
        e.stopPropagation();
        // Toggle active class
        var isActive = wrap.classList.contains('hc-tooltip-active');
        // Remove all active tooltips first
        document.querySelectorAll('.hc-tooltip-wrap.hc-tooltip-active').forEach(function (el) {
          el.classList.remove('hc-tooltip-active');
        });
        if (!isActive) {
          wrap.classList.add('hc-tooltip-active');
          // Auto-hide after 4 seconds
          setTimeout(function () {
            wrap.classList.remove('hc-tooltip-active');
          }, 4000);
        }
      } else {
        // Clicked outside - close any active tooltip
        document.querySelectorAll('.hc-tooltip-wrap.hc-tooltip-active').forEach(function (el) {
          el.classList.remove('hc-tooltip-active');
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

